/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { SystemEntity } from '../models/system-entity';

/**
 * DTO for a Regarding object
 */
export interface Regarding {

  /**
   * ID
   */
  id?: string | null;

  /**
   * Name
   */
  name?: string | null;

  /**
   * Where possible, if the Regarding object is ultimately linked to a party
   * Record the partyid here also (for ease of querying/reporting later)
   */
  partyId?: string | null;
  type?: SystemEntity;
}

export class Regarding {
  id?: string | null;
  name?: string | null;
  partyId?: string | null;
  type?: SystemEntity;

  constructor(value: Regarding) {
    this.id = value?.id;
    this.name = value?.name;
    this.partyId = value?.partyId;
    this.type = value?.type ? Object.entries(Object.values(SystemEntity)).flatMap((x) => x).find(x => x === value.type) as SystemEntity : undefined;
  }
}
